import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.rolle-mitteilungs-vorlage-liste';
import * as api from '../../../clients/kommunikation';

@Injectable()
export class KommunikationRolleMitteilungsVorlageListeEffects {

    RolleMitteilungsVorlageListe$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_ROLLE_MITTEILUNGS_VORLAGE_LISTE),
        mergeMap((x: ac.GetRolleMitteilungsVorlageListeAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getRolleMitteilungsVorlageListe(x.rolle_id).pipe(
                map((result: any) => {
                    return new ac.GetRolleMitteilungsVorlageListeErfolgreichAction(result, x.rolle_id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetRolleMitteilungsVorlageListeFehlerAction(error, x.rolle_id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.MitteilungsVorlageQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.MitteilungsVorlageQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.MitteilungsVorlageQueryService);
        }
        return this.service;
    }
}
